// extracted by mini-css-extract-plugin
export default {"flash":"flashScreen_flash__ahcfR","flash__img":"flashScreen_flash__img__7-SPB","flash__text":"flashScreen_flash__text__N1Kdr"};